export default "__VITE_ASSET__CWYgbTpP__"